import { render, staticRenderFns } from "./IpoResultLockup.vue?vue&type=template&id=b0375f02&scoped=true"
import script from "./IpoResultLockup.vue?vue&type=script&lang=js"
export * from "./IpoResultLockup.vue?vue&type=script&lang=js"
import style0 from "./IpoResultLockup.vue?vue&type=style&index=0&id=b0375f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0375f02",
  null
  
)

export default component.exports